import { TRENDING_SEARCHES_COUNT } from '../constants/cioConstants';

/**
 * @function getTrendingSearches
 * @description This function is responsible for fetching trending searches from the CIO API
 * @return {Array}
 */
export const getTrendingSearches = async ({ cioClient }) => {
  const cioResults = await cioClient.recommendations.getRecommendations(
    'trending-searches',
    {
      section: 'Search Suggestions',
      numResults: TRENDING_SEARCHES_COUNT,
    }
  );

  return {
    trendingSearches: cioResults?.response?.results,
    podId: cioResults?.response?.pod?.id,
    resultId: cioResults?.result_id,
  };
};
